export default function sendGtmEvent(name, data) {
  window.dataLayer?.push({
    event: name,
    data
  });
}
